
import ClubJoinDialog from '~/components/organisms/clubs/ClubJoinDialog.vue'

export default {
  components: { ClubJoinDialog },

  props: {
    signupRoute: {
      type: [Object, String],
      default: undefined,
    },
  },

  methods: {
    setDialogJoinClubOpen() {
      this.$store.commit('clubs/setIsDialogJoinClubOpen', true)
    },
  },
}
